import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=63ca8017&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=63ca8017&prod&lang=scss&scoped=true"
import style1 from "./Navbar.vue?vue&type=style&index=1&id=63ca8017&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ca8017",
  null
  
)

export default component.exports